// Styles for TopNavigation go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
export const StyledTopNavigation = styled.div`
  .mobile-background {
    background-color: ${baseVariables.color['base10']};
    opacity: 65%;
  }
  .dark-theme {
    width: 100%;
    background-color: ${baseVariables.color['base10']};
    .background-aware-logo svg path {
      fill: ${baseVariables.color['base20']} !important;
    }
    &:hover .background-aware-logo svg path {
      fill: ${baseVariables.color['base10']} !important;
    }

    .luxury-logo a {
      color: ${baseVariables.color['base20']};
      font-weight: 500;
    }
    .hamburger-menu {
      color: ${baseVariables.color['base20']};
    }

    @media ${baseVariables.mediaQuery.lg} {
      .language-selector-button {
        a {
          color: ${baseVariables.color['base20']};
        }
      }
    }
    @media ${baseVariables.mediaQuery.lg} {
      &:hover {
        background-color: ${baseVariables.color['base20']};
        opacity: 100%;
        li a {
          color: ${baseVariables.color['base10']};
        }
        .luxury-logo a {
          color: ${baseVariables.color['base10']};
          font-weight: 500;
        }

        .language-selector-button {
          a {
            color: ${baseVariables.color['base10']};

            &:hover {
              border-bottom: 0;
              padding-bottom: 0;
            }
          }
        }
      }
    }
    opacity: 65%;
    @media ${baseVariables.mediaQuery.lg} {
      li a {
        color: ${baseVariables.color['base20']};
        &:hover,
        &.active {
          border-bottom: solid ${toRem(3)} ${baseVariables.color['base10']};
          padding-bottom: ${toRem(4)};
        }
      }
      .main-nav__menu-btn {
        color: ${baseVariables.color['base20']};
      }
    }
  }
  .light-theme {
    background-color: ${baseVariables.color['base20']};
    .hamburger-menu {
      color: ${contextualVariable.brandFgColor};
    }
    .luxury-logo a {
      color: ${baseVariables.color['base10']};
      font-weight: 500;
    }
    li a {
      color: ${baseVariables.color['base10']};
      &:hover,
      &.active {
        border-bottom: solid ${toRem(3)} ${baseVariables.color['base10']};
        padding-bottom: ${toRem(4)};
      }
    }
  }
  .m-header-container {
    .nav-container {
      padding: ${toRem(28)} ${toRem(12)};
    }
  }
  .header-overlay {
    background-color: white;
    z-index: 999;
    position: fixed;
    height: 100vh;
    width: 100vw;
  }

  .main-nav {
    list-style: none;
    &__content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0 ${toRem(16)};
      @media ${baseVariables.mediaQuery.md} {
        padding: 0 ${toRem(24)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding: 0 ${toRem(16)};
      }
      @media ${baseVariables.mediaQuery.xl} {
        padding: 0 ${toRem(150)};
      }
      .logo-wrapper {
        display: flex;
        align-items: center;
        margin-right: ${toRem(32)};
        [dir='rtl'] & {
          margin-left: ${toRem(32)};
          margin-right: 0;
        }
        height: ${toRem(52)};
        padding: ${toRem(10)} 0;
        .icon-clear {
          color: ${contextualVariable.brandFgColor};
        }
        .brand-logo-luxury-Mark {
          font-size: ${toRem(24)};
          @media ${baseVariables.mediaQuery.md} {
            font-size: ${toRem(32)};
          }
        }
        @media ${baseVariables.mediaQuery.md} {
          height: ${toRem(88)};
        }
        @media ${baseVariables.mediaQuery.lg} {
          width: auto;
        }
      }
    }
    &__open {
      display: block;
      position: fixed;
      background: white;
      z-index: 999;
      opacity: 100%;
      overflow: hidden;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      height: 100vh;
      height: 100dvh;
      min-height: 100vh;
      min-height: 100dvh;
      min-height: -webkit-fill-available;
      .luxury-logo a {
        color: ${baseVariables.color['base10']};
      }
      .position-static {
        position: static;
        width: auto;
      }
    }
    &__nav-items {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral20']};
      padding: ${toRem(24)} 0 ${toRem(24)} 0;
      @media ${baseVariables.mediaQuery.lg} {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0;
        margin: ${toRem(28)} 0;
        border-top: none;
        .luxury-logo {
          margin-right: ${toRem(32)};
        }
      }
    }

    &__nav-item {
      padding: ${toRem(14)} 0 ${toRem(10)};
      border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral20']};

      a.m-nav-link {
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        font-size: ${toRem(16)};
        line-height: ${toRem(24)};
        @media ${baseVariables.mediaQuery.desktop} {
          padding: ${toRem(4)} 0;
          margin: 0;
          white-space: nowrap;
          font-size: ${toRem(14)};
          line-height: ${toRem(14)};
          font-weight: 700;
          &:focus {
            border-bottom: unset;
          }
          &:hover,
          &.active {
            border-bottom: solid ${toRem(3)};
            padding-bottom: ${toRem(4)};
          }
        }
      }

      .main-nav__nav-link-arrow {
        height: ${toRem(24)};
        ::before {
          font-size: ${toRem(24)};
        }
      }

      @media ${baseVariables.mediaQuery.lg} {
        border-bottom: unset;
        padding: 0;
        margin-right: ${toRem(20)};
        padding-bottom: ${toRem(5)};
      }
    }

    .exlpore-all {
      margin-left: ${toRem(40)};
    }

    &__menu-btn {
      padding-right: ${toRem(24)};
      padding-left: 0;
      @media ${baseVariables.mediaQuery.md} {
        padding-right: ${toRem(32)};
      }
      [dir='rtl'] & {
        padding-left: ${toRem(24)};
        padding-right: 0;
        @media ${baseVariables.mediaQuery.md} {
          padding-left: ${toRem(32)};
        }
      }
      span {
        height: ${toRem(32)};
        width: ${toRem(32)};
        display: block;
      }
    }

    &__btn {
      border: 0;
      background-color: transparent;
      .standard & {
        .icon-menu::before {
          color: inherit;
        }
      }
      [class*='icon-'] {
        &::before {
          display: block;
          padding: 0 ${toRem(4)};
        }
      }
    }
    &__nav {
      position: absolute;
      top: ${toRem(52)};
      height: calc(100vh - ${toRem(52)});
      width: 100vw;
      display: none;
      overflow: auto;
      flex-direction: column;
      z-index: 1;
      @media ${baseVariables.mediaQuery.sm} {
        top: ${toRem(88)};
        width: 100vw;
        height: calc(100vh - ${toRem(88)});
      }
      @media ${baseVariables.mediaQuery.lg} {
        position: static;
        display: inline-flex;
        background: none;
        overflow: visible;
        height: 100%;
        width: 100%;
        flex-direction: unset;
      }
      &-link {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__overlay {
      @media ${baseVariables.mediaQuery.sm} {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: -1;
      }
      @media ${baseVariables.mediaQuery.lg} {
        display: none;
      }
    }
  }

  .sticky-nav-bar-bottom {
    top: ${toRem(-110)};
    position: absolute;
    z-index: 50;
    width: 100vw;
    transition: top 0.4s ease;
  }

  .sticky-nav-bar-top {
    top: 0;
    position: fixed;
    z-index: 50;
    width: 100vw;
    transition: top 0.4s ease;
    -webkit-backdrop-filter: blur(${toRem(1)});
    backdrop-filter: blur(${toRem(2)});
  }

  .nav-bar-overlay {
    position: relative;
    z-index: 99;

    .modal-popup-container {
      bottom: 0 !important;
    }

    .modal-main-container {
      bottom: 0 !important;
    }
  }

  .language-selector-button {
    position: absolute;
    bottom: ${toRem(54)};

    .modal-popup-container {
      bottom: -100vh;
    }

    .modal-main-container {
      bottom: -100vh;

      @media ${baseVariables.mediaQuery.md} {
        bottom: 0;
      }
    }

    @media ${baseVariables.mediaQuery.lg} {
      display: flex !important;
      position: relative;
      margin-top: ${toRem(0)};
      margin-left: auto;
      bottom: 0;

      [dir='rtl'] & {
        margin-left: unset;
        margin-right: auto;
      }
    }

    a.language-selector-button {
      cursor: pointer;
      align-items: center;

      &:hover {
        font-weight: 500 !important;
      }
    }

    h4 {
      cursor: default;
    }
  }
`;
